import { DataTable, Tbody, Th, Td, Thead, Tr, Typography } from "@visa/vds";

import React from "react";
import { RecurringType, SubscriptionType } from "../../../../_constants/SubscriptionConstants";
import { DateHelper } from "../../../../_helpers/DateHelper";
import "./SubscriptionInformation.css";
import { AlignRight } from "pages/3DSStore/PurchaseProduct/Components/FeeWaiver/FeeWaiverLogic";

const SubscriptionInformation = (props) => {
  const { products, subscriptionDetails, feeWaiverDetails } = props

  const renderHeader = () => {
    return (
      <>
        {!!subscriptionDetails.subscriptionFee ? <Th style={AlignRight}>Subscription Fee</Th> : ""}
        {!!subscriptionDetails.setupFee ? <Th style={AlignRight}>One Time Fee</Th> : ""}
        {!!subscriptionDetails.monthlyFee ? <Th style={AlignRight}>Monthly Fee</Th> : ""}
        {!!subscriptionDetails.yearlyFee ? <Th style={AlignRight}>Yearly Fee</Th> : ""}
      </>
    );
  };

  const renderSubscriptionCells = (item) => {
    return (
      <>
        {!!item.startDate && (
          <>
            <br />
            <span>
              <b>Start Date:</b> {DateHelper.ToLocaleDateString(item.startDate)}
            </span>
          </>
        )}
        {!!item.endDate && (
          <>
            <br />
            <span>
              <b>End Date:</b> {DateHelper.ToLocaleDateString(item.endDate)}
            </span>
          </>
        )}
      </>
    );
  };

  function renderEmptyFeeCell(item) {
    return !!item ? <Td></Td> : "";
  }

  function renderFeeCell(item) {
    if (item == null) return;
    return <Td style={AlignRight} className={`td-fee${(item[0] === "-" || item < 0) && "-negative"}`}>{item}</Td>;
  }

  const renderFeeCells = (subscription) => {
    switch (subscription.subscriptionType) {
      case SubscriptionType.Subscription:
        return renderFeeCell(subscription.feeString);
      case SubscriptionType.Setup:
      case SubscriptionType.Recurring:
        return (
          <>
            {subscription.subscriptionType == SubscriptionType.Setup
              ? renderFeeCell(subscription.feeString)
              : renderEmptyFeeCell(subscriptionDetails.setupFee)}
            {subscription.subscriptionType == SubscriptionType.Recurring &&
              subscription.recurringType == RecurringType.Monthly
              ? renderFeeCell(subscription.feeString)
              : renderEmptyFeeCell(subscriptionDetails.monthlyFee)}
            {subscription.subscriptionType == SubscriptionType.Recurring &&
              subscription.recurringType == RecurringType.Annual
              ? renderFeeCell(subscription.feeString)
              : renderEmptyFeeCell(subscriptionDetails.yearlyFee)}
          </>
        );
    }
  };

  const renderTotalFeeRow = () => {
    function renderTotalFeeCell(item) {
      return !!item ? <Td style={AlignRight} className="td-fee">{item}</Td> : "";
    }
    return (
      <>
        <Td className="td-total" colSpan={2}>
          TOTAL
        </Td>
        {renderTotalFeeCell(subscriptionDetails.subscriptionFee)}
        {renderTotalFeeCell(subscriptionDetails.setupFee)}
        {renderTotalFeeCell(subscriptionDetails.monthlyFee)}
        {renderTotalFeeCell(subscriptionDetails.yearlyFee)}
      </>
    );
  };

  const shouldShowFeeWaiverRow = (product) => {
    return feeWaiverDetails != null && feeWaiverDetails.productId === product.subscriptions[0].productId;
  }

  const renderFeeWaiverRow = (product) => {
    return (
      <>
        {shouldShowFeeWaiverRow(product) &&
          <Tr>
            <Td width="35%">
              <b>Fee Waiver or Fee Discount Applied: </b>{feeWaiverDetails.description}
            </Td>
            {feeWaiverDetails.subscriptionType == SubscriptionType.Subscription && renderFeeCell(feeWaiverDetails.productFeeDiscountString)}
            {feeWaiverDetails.subscriptionType != SubscriptionType.Subscription && subscriptionDetails.setupFee && renderFeeCell(feeWaiverDetails.setupFeeDiscountString)}
            {feeWaiverDetails.subscriptionType != SubscriptionType.Subscription && subscriptionDetails.monthlyFee && renderFeeCell(feeWaiverDetails.productFeeDiscountString)}
            {renderEmptyFeeCell(subscriptionDetails.yearlyFee)}
          </Tr>
        }
      </>
    )
  }

  return (
    <>
      <Typography tag="h2">Subscription Information</Typography>
      <DataTable className="table-subscription" size="compact">
        <Thead>
          <Tr>
            <Th>Product Name</Th>
            <Th>Item</Th>
            {renderHeader()}
          </Tr>
        </Thead>{" "}
        <Tbody>
          {products.map((p, key) => (
            <>
              {p.subscriptions &&
                p.subscriptions.map((item, k) => (
                  <Tr>
                    {k == 0 ? (
                      <Td width="35%" rowSpan={p.subscriptions.length + (shouldShowFeeWaiverRow(p) ? 1 : 0)}>
                        <b>{item.productName}</b>
                      </Td>
                    ) : (
                      ""
                    )}
                    <Td width="35%">
                      {item.productSubscriptionInfoName}
                      {item.subscriptionType == SubscriptionType.Subscription
                        ? renderSubscriptionCells(item)
                        : ""}
                    </Td>
                    {renderFeeCells(item)}
                  </Tr>
                ))}
              {renderFeeWaiverRow(p)}
            </>
          ))}
          <Tr className="tr-total">{renderTotalFeeRow()}</Tr>
        </Tbody>
      </DataTable>
    </>
  );
};

export default SubscriptionInformation;
